import React, { Component } from "react";

import { Helmet } from "react-helmet";

import TextBlock from "components/TextBlock/TextBlock";
import Hero from "components/PageHero/Hero";
import TeamMember from "components/TeamMember/TeamMember";
import TeamSlider from "components/TeamSlider/TeamSlider";
import TeamGrid from "components/TeamGrid/TeamGrid";
import TeamItem from "components/TeamGrid/TeamItem";
import { toggleReadmore } from "helpers/Helpers";
import { I18n } from "react-i18next";
import i18n from "../i18n";

import InformationItem from "components/InformationItem/Information-Item";
import InformationIntro from "components/InformationItem/Information-IntroItem";
import Button from "components/Button/Button";

//content
import Over from "assets/images/About/video-screenshots/screen-video-over-fpg-2.jpg";

import Bianca from "assets/images/About/02_Toppers-los/FPG-bianca-vierkant.jpg";
import Corne from "assets/images/About/02_Toppers-los/FPG-corne-vierkant.jpg";
import Erik from "assets/images/About/02_Toppers-los/FPG-erik-vierkant.jpg";
import Monique from "assets/images/About/02_Toppers-los/FPG-monique-vierkant.jpg";
import Remco from "assets/images/About/02_Toppers-los/FPG-remco-vierkant.jpg";
import Richard from "assets/images/About/02_Toppers-los/FPG-richard-vierkant.jpg";
import Thom from "assets/images/About/02_Toppers-los/FPG-thom-vierkant.jpg";
import Annette from "assets/images/About/02_Toppers-los/FPG-annette-van-den-dolder.jpg";
import Jory from "assets/images/About/02_Toppers-los/FPG-jory-spaans.jpg";
import Nealy from "assets/images/About/02_Toppers-los/FPG-nealy-van-den-berg.jpg";
import Diana from "assets/images/About/02_Toppers-los/FPG-diana-vierkant.jpg";

import TeamProductie from "assets/images/About/03_Toppers-teams/01-productieteam.jpg";
import TeamDokters from "assets/images/About/03_Toppers-teams/02-plantendokters.jpg";
import TeamAflever from "assets/images/About/03_Toppers-teams/03-afleverteam.jpg";
import teamSales from "assets/images/About/03_Toppers-teams/04-salesteam.jpg";

import What from "assets/images/About/07_Foto-Work-with-us/what-nieuw.jpg";
import WhatHq from "assets/images/About/07_Foto-Work-with-us/hq/what-nieuw.jpg";
import Work from "assets/images/About/07_Foto-Work-with-us/work-with-us-4.jpg";
import Import from "assets/images/About/08_Foto-Import/own-import.jpg";
import Proces from "assets/images/About/video-screenshots/screen-video-proces.jpg";
import Dokter from "assets/images/About/video-screenshots/screen-video-plantendokter.jpg";

export default class About extends Component {
  componentDidMount() {
    document.body.classList.add("about-page");
  }
  componentWillUnmount() {
    document.body.classList.remove("about-page");
  }
  render() {
    return [
      <I18n>
        {(t, { i18n }) => (
          <Helmet key="head">
            <meta charSet="utf-8" />
            <title>
              Over FPG | Forever Plants | Ontdek waar FPG voor staat
            </title>
            <meta
              property="og:image"
              content={`${process.env.REACT_APP_SAFE_URL}${Over}`}
            />
            <meta
              name="description"
              content="We vertellen graag over onszelf. Nog liever vertellen we over waar Forever Plants Group voor staat en wat we willen bereiken met de planten die we grootbrengen. Lees hier alles over het groener maken van woonkamers, bedrijven, levens en uiteindelijk ook de hele wereld. Ambitieus? Zeker. Onmogelijk? Niet als jij ook meehelpt."
            />
            <meta
              property="og:description"
              content="We vertellen graag over onszelf. Nog liever vertellen we over waar Forever Plants Group voor staat en wat we willen bereiken met de planten die we grootbrengen. Lees hier alles over het groener maken van woonkamers, bedrijven, levens en uiteindelijk ook de hele wereld. Ambitieus? Zeker. Onmogelijk? Niet als jij ook meehelpt."
            />
          </Helmet>
        )}
      </I18n>,
      <I18n>
        {(t, { i18n }) => (
          <div id="pageWrapper" key="content">
            <div className="wrapper-hero-video">
              <Hero
                imageSrc={Over}
                videoId="257493423"
                channel="vimeo"
                showSubtitle
              />
            </div>
            <div className="wrapper">
              <section className="mini-manifest">
                <TextBlock
                  title={t("aboutMiniTitle")}
                  subtitle={t("aboutMiniSubTitle")}
                  extraClasses="textblock-big textblock-no-mobile-overflow"
                  id="manifest-textblock"
                >
                  {t("aboutMiniText1")}
                  <br />
                  <br />
                  {t("aboutMiniText2")}{" "}
                  <Button to="educatie" delay={true}>
                    {t("aboutMiniPowerBtn")}
                  </Button>
                  {t("aboutMiniText3")}
                  <br />
                  <br />
                  {t("aboutMiniText4")}
                </TextBlock>
                <a
                  href="#!"
                  id="read-more"
                  className="mt10 text-anchor read-more"
                  onClick={toggleReadmore(
                    "manifest-textblock",
                    "read-more",
                    t("aboutReadMore"),
                    t("aboutReadLess")
                  )}
                >
                  {t("aboutReadMore")}
                </a>
              </section>
              <section className="Our-team mt100">
                <TextBlock extraClasses="mb32" title={t("aboutOurGreats")} />
                <TeamSlider>
                  <TeamMember
                    image={Richard}
                    name="Richard Visser"
                    department={t("aboutDepartmentSalesManager")}
                    email="richard@foreverplants.nl"
                    key="0"
                  />
                  <TeamMember
                    image={Corne}
                    name="Corné van Winden"
                    department={t("aboutDepartmentSales")}
                    email="corne@foreverplants.nl"
                    key="1"
                  />
                  <TeamMember
                    image={Jory}
                    name="Jory Spaans"
                    department={t("aboutDepartmentSales")}
                    email="jory@foreverplants.nl"
                    key="4"
                  />
                  <TeamMember
                    image={Annette}
                    name="Annette van den Dolder"
                    department={t("aboutDepartmentSalesOffice")}
                    email="annette@foreverplants.nl"
                    key="5"
                  />
                  <TeamMember
                    image={Nealy}
                    name="Nealy van den Berg"
                    department={t("aboutDepartmentSalesOffice")}
                    email="nealy@foreverplants.nl"
                    key="5"
                  />
                  <TeamMember
                    image={Bianca}
                    name="Bianca van Dijk"
                    department={t("aboutDepartmentNewBusiness")}
                    email="bianca@foreverplants.nl"
                    key="3"
                  />
                  <TeamMember
                    image={Thom}
                    name="Thom Persoon"
                    department={t("aboutDepartmentManagement")}
                    email="thom@foreverplants.nl"
                    key="10"
                  />
                  <TeamMember
                    image={Diana}
                    name="Diane Prins"
                    department="HR Manager"
                    email="diane@foreverplants.nl"
                    key="11"
                  />
                  <TeamMember
                    image={Remco}
                    name="Remco Hill"
                    department={t("aboutDepartmentManagement")}
                    email="remco@foreverplants.nl"
                    key="7"
                  />
                  <TeamMember
                    image={Erik}
                    name="Erik Persoon"
                    department={t("aboutDepartmentManagement")}
                    email="erik@foreverplants.nl"
                    key="8"
                  />
                  <TeamMember
                    image={Monique}
                    name="Monique Persoon"
                    department={t("aboutDepartmentAdministration")}
                    email="monique@foreverplants.nl"
                    key="9"
                  />
                </TeamSlider>
              </section>
              <section className="information-teams mt150">
                <TeamGrid>
                  <TeamItem
                    image={TeamDokters}
                    imageHq={TeamDokters}
                    title={t("aboutOurPlantDoctors")}
                  />
                  <TeamItem
                    image={TeamProductie}
                    imageHq={TeamProductie}
                    title={t("aboutOurProduction")}
                  />
                  <TeamItem
                    image={TeamAflever}
                    imageHq={TeamAflever}
                    title={t("aboutOurDelivery")}
                  />
                  <TeamItem
                    image={teamSales}
                    imageHq={teamSales}
                    title={t("aboutOurSales")}
                  />
                </TeamGrid>
              </section>
              <section id="more-about-us" className="mt150">
                <InformationIntro
                  imageSrc={What}
                  imageSrcHq={WhatHq}
                  informationMedia="informationMedia-intro "
                  informationContent="informationContent pl40"
                  h3className="informationTitle mb0"
                  h4SubclassName="subtitle"
                  pClassName="informationParagraph"
                  SubTitle={t("aboutWhatSubTitle")}
                  Title={t("aboutWhatTitle")}
                >
                  {t("aboutWhatText")} <br />
                  <Button to="educatie" delay={true}>
                    {t("aboutWhatBtn")}
                  </Button>
                </InformationIntro>
                <InformationItem
                  informationMedia="wrapper-hero-video informationMedia informationMedia-video order2"
                  videoLink=""
                  channel="vimeo"
                  pictureURL={Import}
                  informationContent="informationContent"
                  h3className="informationTitle mb0"
                  pClassName="informationParagraph"
                  Title={t("aboutImportTitle")}
                >
                  {t("aboutImportText")}
                  <Button
                    className="btn btn-modifier__position positionA"
                    to="/blog/groene-planten-waar-komen-ze-vandaan"
                    onClick=""
                  >
                    {t("aboutImport")}
                  </Button>
                </InformationItem>
                <InformationItem
                  informationMedia="wrapper-hero-video informationMedia informationMedia-video ml0 mr0"
                  videoLink={t("aboutDoctorVideo")}
                  channel="vimeo"
                  pictureURL={Dokter}
                  informationContent="informationContent pl40"
                  h3className="informationTitle mb0"
                  pClassName="informationParagraph"
                  Title={t("aboutDoctorTitle")}
                >
                  {t("aboutDoctorText")}
                </InformationItem>
                <InformationItem
                  informationMedia="wrapper-hero-video informationMedia informationMedia-modifier order2"
                  videoLink=""
                  channel="vimeo"
                  pictureURL={Work}
                  informationContent="informationContent informationContent-modifier"
                  h3className="informationTitle mb0"
                  pClassName="informationParagraph informationParagraph-modifier positionR"
                  Title={t("aboutWorkTitle")}
                >
                  {t("aboutWorkText")}
                  <Button
                    className="btn btn-modifier__position positionA"
                    to="contact"
                    onClick=""
                  >
                    {t("aboutContact")}
                  </Button>
                </InformationItem>
              </section>
            </div>
          </div>
        )}
      </I18n>,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/Pages/About.jsx